import { getHandler, patchHandler, postHandler } from 'src/utils/fetchHandler';
import {
	getPendingAppOrganizationUpdate,
	getPendingAppOrganizationCreate,
} from './appOrganization.selector';

export const CLEAR_APP_ORGANIZATIONS = 'CLEAR_APP_ORGANIZATIONS/APP_ORGANIZATION/@WISELY/WEB';
export const CLEAR_APP_ORGANIZATION_UPDATE_ERRORS =
	'CLEAR_APP_ORGANIZATION_UPDATE_ERRORS/APP_ORGANIZATION/@WISELY/WEB';
export const CLEAR_APP_ORGANIZATION_CREATE_ERRORS =
	'CLEAR_APP_ORGANIZATION_CREATE_ERRORS/APP_ORGANIZATION/@WISELY/WEB';
export const GET_APP_ORGANIZATION = 'GET_APP_ORGANIZATION/APP_ORGANIZATION/@WISELY/WEB';
export const GET_APP_ORGANIZATIONS = 'GET_APP_ORGANIZATIONS/APP_ORGANIZATION/@WISELY/WEB';
export const FETCH_APP_ORGANIZATION_FAILED =
	'FETCH_APP_ORGANIZATION_FAILED/APP_ORGANIZATION/@WISELY/WEB';
export const FETCH_APP_ORGANIZATION_SUCCEEDED =
	'FETCH_APP_ORGANIZATION_SUCCEEDED/APP_ORGANIZATION/@WISELY/WEB';
export const FETCH_APP_ORGANIZATIONS_FAILED =
	'FETCH_APP_ORGANIZATIONS_FAILED/APP_ORGANIZATION/@WISELY/WEB';
export const FETCH_APP_ORGANIZATIONS_SUCCEEDED =
	'FETCH_APP_ORGANIZATIONS_SUCCEEDED/APP_ORGANIZATION/@WISELY/WEB';
export const UPDATE_APP_ORGANIZATION = 'UPDATE_APP_ORGANIZATION/APP_ORGANIZATION/@WISELY/WEB';
export const UPDATE_APP_ORGANIZATION_FAILED =
	'UPDATE_APP_ORGANIZATION_FAILED/APP_ORGANIZATION/@WISELY/WEB';
export const UPDATE_APP_ORGANIZATION_SUCCEEDED =
	'UPDATE_APP_ORGANIZATION_SUCCEEDED/APP_ORGANIZATION/@WISELY/WEB';
export const CREATE_APP_ORGANIZATION = 'CREATE_APP_ORGANIZATION/APP_ORGANIZATION/@WISELY/WEB';
export const CREATE_APP_ORGANIZATION_FAILED =
	'CREATE_APP_ORGANIZATION_FAILED/APP_ORGANIZATION/@WISELY/WEB';
export const CREATE_APP_ORGANIZATION_SUCCEEDED =
	'CREATE_APP_ORGANIZATION_SUCCEEDED/APP_ORGANIZATION/@WISELY/WEB';

export const clearAppOrganizations = () => ({
	type: CLEAR_APP_ORGANIZATIONS,
});

export const clearAppOrganizationUpdateErrors = () => ({
	type: CLEAR_APP_ORGANIZATION_UPDATE_ERRORS,
});

export const clearAppOrganizationCreateErrors = () => ({
	type: CLEAR_APP_ORGANIZATION_CREATE_ERRORS,
});

export const getAppOrganization = () => ({
	type: GET_APP_ORGANIZATION,
});

export const getAppOrganizations = () => ({
	type: GET_APP_ORGANIZATIONS,
});

export const fetchAppOrganizationFailed = payload => ({
	type: FETCH_APP_ORGANIZATION_FAILED,
	payload,
});

export const fetchAppOrganizationSucceeded = payload => ({
	type: FETCH_APP_ORGANIZATION_SUCCEEDED,
	payload,
});

export const fetchAppOrganizationsFailed = payload => ({
	type: FETCH_APP_ORGANIZATIONS_FAILED,
	payload,
});

export const fetchAppOrganizationsSucceeded = payload => ({
	type: FETCH_APP_ORGANIZATIONS_SUCCEEDED,
	payload,
});

export const fetchAppOrganization = (id, params) => {
	return dispatch => {
		dispatch(getAppOrganization());
		const path = `v2/organizations/${id}`;

		return getHandler(path, params)
			.then(json => dispatch(fetchAppOrganizationSucceeded(json)))
			.catch(error => {
				console.error('fetchAppOrganization error', error);
				dispatch(fetchAppOrganizationFailed());
			});
	};
};

export const fetchAppOrganizations = params => {
	return async dispatch => {
		dispatch(getAppOrganizations());
		const path = 'v2/organizations';

		return getHandler(path, params)
			.then(json => dispatch(fetchAppOrganizationsSucceeded(json)))
			.catch(error => {
				console.error('fetchAppOrganizations error', error);
				dispatch(fetchAppOrganizationsFailed(error));
			});
	};
};

export const updateAppOrganization = () => ({
	type: UPDATE_APP_ORGANIZATION,
});

export const requestUpdateAppOrganizationFailed = payload => ({
	type: UPDATE_APP_ORGANIZATION_FAILED,
	payload,
});

export const requestUpdateAppOrganizationSucceeded = payload => ({
	type: UPDATE_APP_ORGANIZATION_SUCCEEDED,
	payload,
});

export const requestUpdateAppOrganization = (id, body) => {
	return async (dispatch, getState) => {
		if (getPendingAppOrganizationUpdate(getState())) {
			return;
		}
		dispatch(updateAppOrganization());
		const path = `v2/organizations/${id}`;

		return patchHandler(path, JSON.stringify(body))
			.then(json => dispatch(requestUpdateAppOrganizationSucceeded(json)))
			.catch(error => {
				console.error('requestUpdateAppOrganization error', error);
				dispatch(requestUpdateAppOrganizationFailed(error));
			});
	};
};

export const createAppOrganization = () => ({
	type: CREATE_APP_ORGANIZATION,
});

export const requestCreateAppOrganizationFailed = payload => ({
	type: CREATE_APP_ORGANIZATION_FAILED,
	payload,
});

export const requestCreateAppOrganizationSucceeded = payload => ({
	type: CREATE_APP_ORGANIZATION_SUCCEEDED,
	payload,
});

export const requestCreateAppOrganization = body => {
	return async (dispatch, getState) => {
		if (getPendingAppOrganizationCreate(getState())) {
			return;
		}
		dispatch(createAppOrganization());
		const path = `v2/organizations`;

		return postHandler(path, JSON.stringify(body))
			.then(json => dispatch(requestCreateAppOrganizationSucceeded(json)))
			.catch(error => {
				console.error('requestCreateAppOrganization error', error);
				dispatch(requestCreateAppOrganizationFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/appOrganizations/appOrganization.action.js